import styled from '@emotion/styled'
import {
  IconButton as MaterialIconButton,
  Fab,
} from '@material-ui/core'

export const IconButton = styled(MaterialIconButton)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FloatingButton = styled(Fab)`
  display: flex;
  align-items: center;
  justify-content: center;
`
